export default "__VITE_ASSET__gREO$CQb__"